export default __webpack_public_path__ + "static/media/cimb.798d0c25.svg";